import React, { JSX } from 'react'

import styled, { css } from 'styled-components'

const FilterContainer = styled.div`
  display: flex;
  width: fit-content;

  ${({ theme }) => {
    return css`
      margin-top: auto;

      @media ${theme.mediaQueries.mobile} {
        width: 100%;
        grid-column: 1 / span 2;
        justify-content: space-between;
        grid-row: 2;
        margin-top: 2rem;
      }
    `
  }};
`

const FilterButton = styled.button<{ active?: boolean }>`
  border: none;
  cursor: pointer;

  ${({ theme, active }) => css`
    color: ${active
      ? theme.palette.neutral.white
      : theme.palette.brand.darkPurple};
    background-color: ${active
      ? theme.palette.brand.newPurple
      : theme.palette.brand.lightPurple};
    padding: 0.125rem 0.75rem;
    font-size: 0.875rem;
    border-radius: 0.25rem;
    line-height: 1.5rem;
    font-weight: 500;
    text-transform: uppercase;

    &:not(:last-child) {
      margin-right: 0.5rem;
    }
  `}
`

export interface TabFilterProps<
  Opts extends Readonly<
    {
      value: string
      label: string
    }[]
  >
> {
  readonly options: Opts
  readonly defaultValue?: Opts[number]['value']
  onSelect(item: Opts[number]['value']): void
  value?: Opts[number]['value'] | null
}

export const TabFilter = <
  Opts extends Readonly<
    {
      value: string
      label: string
    }[]
  >
>({
  options,
  value,
  defaultValue,
  onSelect,
}: TabFilterProps<Opts>): JSX.Element => (
  <FilterContainer>
    {options.map(opt => {
      const onClick = () => onSelect(opt.value)
      const active = value ? value === opt.value : defaultValue === opt.value

      return (
        <FilterButton
          key={opt.value}
          active={active}
          onClick={onClick}
          type="button"
        >
          {opt.label}
        </FilterButton>
      )
    })}
  </FilterContainer>
)
